import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'dmb-login-errors',
  templateUrl: './login-errors.component.html',
  styleUrls: ['./login-errors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginErrorsComponent {
  readonly status = input(0);
  readonly message = input('');
}
